const ua = require('./module/_ua.js');
const Pjax = require('./_pjax.js');

const isIphone = ua('iphone');
const isAndroid = ua('android');

Pjax.init();

$(function(){
	if(sessionStorage.entrance == 'is--hide'){
		$('.entrance').addClass('is--hide');
	}
});



// if($('body').hasClass('page--top')){
// 	new OnMouseWheel();
// 	$(window).on('load',function(){
// 		setTimeout(function(){
// 			$('.section--mainvisual .title').addClass('is--show');
// 		}, 2000);
// 		setTimeout(function(){
// 			$('.header').addClass('is--show');
// 			$('.information').addClass('is--show');
// 		}, 3000);
// 	});
// 	$('.section--target').on({
// 		mouseover: function(){
// 			$(this).parent().addClass('is--mo');
// 		},
// 		mouseout: function(){
// 			$(this).parent().removeClass('is--mo');
// 		}
// 	});
// }
//
// if($('body').hasClass('page--common')){
// 	$(window).scroll(function () {
// 		if ($(this).scrollTop() > 480) {
// 			$('.header').addClass('is--bg');
// 		} else {
// 			$('.header').removeClass('is--bg');
// 		}
// 	});
// }




// WEBPACK FOOTER //
// ./es2015/app.js